/**
 * Стоимость товаров в корзине из разметки.
 * @type {*|number}
 */
export const cartSum = (window.app && window.app.cartSum) || 0
